import { render, staticRenderFns } from "./KillfeedItemPlant.vue?vue&type=template&id=6fdb9d4a&scoped=true&"
import script from "./KillfeedItemPlant.vue?vue&type=script&lang=js&"
export * from "./KillfeedItemPlant.vue?vue&type=script&lang=js&"
import style0 from "./KillfeedItemPlant.vue?vue&type=style&index=0&id=6fdb9d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdb9d4a",
  null
  
)

export default component.exports